import { Injectable } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { brisbaneToday } from './brisbane-time';

@Injectable()
export class BrisbaneDateFnsAdapter extends DateFnsAdapter {
  override today(): Date {
    return brisbaneToday();
  }
}
